import { IResearchDataResponse, ITileDataPayload } from '@/finsight/domain/vo/research/IResearchResponse';
import ResearchRepository from '@/finsight/infrastructure/repository/ResearchRepository';
import { EXCLUDED_SECTOR_IDS } from '@/finsight/application/actions/deals/constants';
import { getIndustryFilters, getSectorFilters, insertCompanyFilters } from '@/finsight/application/helpers';

export const filterResearchResponse = (
    payload: IResearchDataResponse,
    includedDocumentGroupId: string | null,
) => {
  const data = (
      includedDocumentGroupId
          ? payload.byGroup[includedDocumentGroupId]
          : payload.all);

  return data?.researchCollection;
};

export const getTileDataPayload = (
    isTile: boolean,
    includedDocumentGroupId: string | null = null,
    includedDealIds: string[],
) => <ITileDataPayload>({
  filter: {
    dateFrom: null,
    dateTo: null,
    includedDocumentTypeIds: [],
    includedPseudoSectorIds: [],
    includedPublisherIds: [],
    includedDealIds,
    includedDocumentGroupId,
  },
  sortBy: 'publishedAt',
  sortOrder: 'desc',
  page: 1,
  perPage: isTile ? 10 : 25,
  search: '',
});

export const preparePayloadWithQuery = async (payload, context, isConsumerOverview) => {
  const { query, container } = context;
  const {
    hash,
    q = '',
    dateFrom = '',
    dateTo = '',
    companyViewId,
    sector,
    industry,
  } = query;
  const researchRepository = container.get(ResearchRepository);
  let { filter } = payload;

  if (hash) {
    const hashFilterPayload = await researchRepository.getResearchFilterByHash(hash);
    filter = { ...payload.filter, ...hashFilterPayload };
  }

  if (companyViewId) {
    try {
      const companyFilter = await insertCompanyFilters(context, filter);
      filter = { ...filter, ...companyFilter };
    } catch (e) {
      return { ...payload, filter };
    }
  }

  if (sector) {
    const sectorFilter = getSectorFilters(context);
    filter = { ...filter, ...sectorFilter };
  }

  if (industry) {
    const industryFilter = getIndustryFilters(context);
    filter = { ...filter, ...industryFilter };
  }

  if (isConsumerOverview) filter.excludedSectorIds = EXCLUDED_SECTOR_IDS;

  if (q) payload = { ...payload, search: q };
  if (dateFrom) filter = { ...payload.filter, dateFrom };
  if (dateTo) filter = { ...payload.filter, dateTo };

  return { ...payload, filter };
};
